import { Paper, styled } from '@mui/material';

export const RightDetailContainer = styled(Paper)`
  height: 100%;
  max-height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;
